import {
  privacyLayerSelect,
  privacyLayerSelect2,
  privacyLayerSelect3,
} from "../../Static Files/Static_Labels";

export function getGrommetStepLabels({
  t,
  step3A0,
  step3A,
  step3B,
  selectedSheer,
  step31,
  step3,
  pageLanguage,
  widthCart,
  step2A,
  step6CHead,
  windowWidthPanelType,
}) {
  let windowWidthTitle;
  let sillStepNum;
  let wallExtensionStepNum;
  let privacyLayerStep9;

  if (step3A0 === "Wall" && step3A === "Standard" && (step3B === "Floor" || step3B === "Slight Puddle")) {
    windowWidthTitle = t("5C");
  } else if (step3A0 === "Wall" && step3A === "Standard" && (step3B === "Sill" || step3B === "Apron")) {
    windowWidthTitle = t("5E");
  } else if (step3A0 === "Wall" && step3A === "Wall to Wall" && (step3B === "Sill" || step3B === "Apron")) {
    windowWidthTitle = t("5D");
  } else if (step3A0 === "Wall" && ( step3A === "Left Corner Window" || step3A === "Right Corner Window") && (step3B === "Sill" || step3B === "Apron")) {
    windowWidthTitle = t("5E");
  } else if (step3A === "Wall to Wall" && step3A0 === "Moulding") {
    windowWidthTitle = t("5D");
  } else if (step3A === "Wall to Wall" && step3A0 !== "Moulding") {
    windowWidthTitle = t("5E");
  } else {
    windowWidthTitle = t("5D");
  }

  if (step3A === "Wall to Wall") {
    if (step3A0 === "Ceiling") {
      sillStepNum = t("5D");
    } else if (step3A0 === "Moulding" && step3A !== "Wall to Wall") {
      sillStepNum = t("5D");
    } else if (step3A0 === "Moulding" && step3A === "Wall to Wall" && (step3B === "Sill" || step3B === "Apron")) {
      sillStepNum = t("5D");
    } else {
      sillStepNum = t("5E");
    }
  } else if (
    step3A0 === "Ceiling" &&
    step3A !== "Wall to Wall" &&
    (step3B === "Sill" || step3B === "Apron")
  ) {
    if (step3A0 === "Moulding" && step3A === "Wall to Wall") {
      sillStepNum = t("5D");
    } else {
      sillStepNum = t("5E");
    }
  } else if (step3A0 === "Moulding" && step3A !== "Wall to Wall") {
    sillStepNum = t("5E");
  } else {
    sillStepNum = t("5F");
  }

  if (step3A0 !== "Wall") {
    if (step3A === "Wall to Wall") {
      if (step3A0 === "Ceiling") {
        wallExtensionStepNum = t("5E");
      } else {
        if (step3A === "Wall to Wall" && step3A0 === "Moulding" && (step3B === "Sill" || step3B === "Apron")) {
          wallExtensionStepNum = t("5E");
        } else {
          wallExtensionStepNum = t("5F");
        }
      }
    } else if (step3A0 === "Ceiling" && (step3B === "Sill" || step3B === "Apron")) {
      wallExtensionStepNum = t("5F");
    }else if (step3A0 === "Moulding" && (step3B === "Sill" || step3B === "Apron") && (step3A === "Left Corner Window" || step3A === "Right Corner Window" || step3A === "Standard")) {
      wallExtensionStepNum = t("5F");
    } else {
      wallExtensionStepNum = t("5G");
    }
  } else if (step3A === "Wall to Wall" && step3A0 !== "Moulding") {
    wallExtensionStepNum = t("5F");
  } else if (step3A === "Wall to Wall" && step3A0 === "Moulding" && (step3B === "Sill" || step3B === "Apron")) {
    wallExtensionStepNum = t("5E");
  } else if (step3A0 === "Wall") {
    wallExtensionStepNum = t("5G");
  } else {
    wallExtensionStepNum = t("5H");
  }

  if (
    selectedSheer &&
    selectedSheer[0] &&
    (selectedSheer[0].num === "3" ||
      selectedSheer[0].num === "4" ||
      selectedSheer[0].num === "5") &&
    step31 === "false" &&
    step3 === "true"
  ) {
    privacyLayerStep9 = privacyLayerSelect2[pageLanguage];
  } else if (parseInt(windowWidthPanelType) <= 160 && step2A === "Grommet") {
    privacyLayerStep9 = privacyLayerSelect[pageLanguage];
  } else if (parseInt(windowWidthPanelType) <= 160 && step2A !== "Grommet") {
    privacyLayerStep9 = privacyLayerSelect3[pageLanguage];
  } else if (step6CHead === "Rod") {
    privacyLayerStep9 = privacyLayerSelect[pageLanguage];
  } else {
    privacyLayerStep9 = privacyLayerSelect2[pageLanguage];
  }

  return {
    windowWidthTitle,
    sillStepNum,
    wallExtensionStepNum,
    privacyLayerStep9,
  };
}
